/**
 * Fork overlay (new file, no OSS equivalent) — EVA-M6.
 * Account-scoped client for the Eva assistants settings API
 * (/api/v1/accounts/:account_id/eva/assistants).
 */
import ApiClient from 'dashboard/api/ApiClient';

class EvaAssistantsAPI extends ApiClient {
  constructor() {
    super('eva/assistants', { accountScoped: true });
  }
}

export default new EvaAssistantsAPI();
